import Vue from 'vue';
import Vuex from 'vuex';
// 登录模块
import Login from './storeModule/login.js';
// 目的港航司检索模块
import DestAirlineSearch from './storeModule/destAirlineSearch.js';
// 正则模块
import Regular from './storeModule/regular.js';
// 收益积分模块
import IncomePoints from './storeModule/incomePoints.js';
// 始发港模块
import StartPort from './storeModule/startPort.js';

Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        // 客服qq
        customerServiceQQ: '',
        // 进口客服qq
        importCustomerServiceQQ: '',
        // 网易七鱼客服加载完毕
        ysfOnReady: false,
        // 网易七鱼客服ID
        customerServiceStaffid: '',
        // 客服Email
        customerServiceEmail: '3j-mall-overseas-customer@job-mate1.com',
        // 进口客服Email
        importEmailCustomerServiceEmail: '',
        // 购物车数量
        shoppingCart: '0',
        // 签到状态（0-未签到、1-已签到）
        integralType: '1',
        // 是否是首页
        isIndexPage: true,
        // 大数据 记录路由切换的时间
        bigData_firstTime: +new Date(),
        // 大数据 记录上一次发送数据时间
        bigData_startTime: +new Date(),
        // 更换头像组件显示隐藏
        isShowHeadPortrait: false,
        // 个人中心路由随机数
        routerPersonalCenterKey: '',
    },
    mutations: {
        customerServiceQQ(state, value) {
            state.customerServiceQQ = value;
        },
        importCustomerServiceQQ(state, value) {
            state.importCustomerServiceQQ = value;
        },
        ysfOnReady(state, value) {
            state.ysfOnReady = value;
        },
        customerServiceStaffid(state, value) {
            state.customerServiceStaffid = value;
        },
        customerServiceEmail(state, value) {
            state.customerServiceEmail = value;
        },
        importEmailCustomerServiceEmail(state, value) {
            state.importEmailCustomerServiceEmail = value;
        },
        shoppingCart(state, value) {
            state.shoppingCart = value;
        },
        integralType(state, value) {
            state.integralType = value;
        },
        isIndexPage(state, value) {
            state.isIndexPage = value;
        },
        bigDataFirstTime(state, value) {
            state.bigData_firstTime = value;
        },
        bigDataStartTime(state, value) {
            state.bigData_startTime = value;
        },
        isShowHeadPortrait(state, value) {
            state.isShowHeadPortrait = value;
        },
        routerPersonalCenterKey(state, value) {
            state.routerPersonalCenterKey = value;
        },
    },
    modules: {
        Login,
        DestAirlineSearch,
        Regular,
        IncomePoints,
        StartPort,
    },
    actions: {}
});
